<template>
  <sidebar
   :addTitle="addNewPageTitle"
   :editTitle="editPageTitle"
   :isSidebarActive="isSidebarActive"
   :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">

    <ValidationObserver v-slot="{ handleSubmit }">

      <form-wizard
        ref="wizard"
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        width="500px"
        :subtitle="null"
        :nextButtonText="$t('Next')"
        :backButtonText="$t('Back')"
        :finishButtonText="$t('Submit')"
        @on-complete="handleSubmit(submitData)"
      >
        <tab-content :title="$t('GradeControl.Timesheet.Step1')" class="mb-2" :before-change="validateStep1">
          <ValidationObserver ref="step1Observer" >
            <!-- Base scenario content -->
            <form data-vv-scope="step-1">
              <vs-row class="mb-3">
                <vs-col class="mr-5" vs-w="6">
                  <form-label>{{$t('GradeControl.ExtractionDate')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.ExtractionDate')" rules="required" v-slot="{ errors }">
                    <datepicker format="yyyy-MM-dd"
                                placeholder="Select Date"
                                v-model="tsExtractionDate"></datepicker>
                    <validation-message
                    >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="5">
                  <form-label>{{$t('GradeControl.Shift')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Shift')" rules="required" v-slot="{ errors }">
                    <v-select
                      :options="shifts"
                      v-model="tsShift"
                      :reduce="shift => shift.id"
                      class="w-full"
                    />
                    <validation-message
                    >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3" v-if="isMuckOperationSelected && !isHaulingOperationSelected">
                <vs-col vs-w="6">
                  <form-label>{{$t('GradeControl.Timesheet.BlastDate')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Timesheet.BlastDate')" v-slot="{ errors }">
                    <datepicker
                      format="yyyy-MM-dd"
                      placeholder="Select Date"
                      v-model="tsBlastDate"
                      class="w-full"
                      wrapper-class="blast-date-picker"
                      input-class="w-full"
                      :clear-button="true"
                    ></datepicker>
                    <validation-message
                    >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <vs-chip class="mt-2 mr-2" color="primary" >
                    {{$t('GradeControl.Timesheet.TimesheetOperationType')}}
                  </vs-chip>
                  <ValidationProvider :name="$t('GradeControl.Timesheet.TimesheetOperationType')" rules="required" v-slot="{ errors }">
                    <v-select
                      label="name"
                      :options="timesheetOperationTypes"
                      v-model="tsTimesheetOperationType"
                      :reduce="timesheetOperationType => timesheetOperationType.id"
                      class="w-full pr-3"
                    />
                    <validation-message
                    >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3" v-if="isMuckOperationSelected">
                <vs-col vs-w="12">
                  <form-label>{{$t('GradeControl.Location.Type')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Location.Type')" rules="required" v-slot="{ errors }">
                    <v-select
                      label="name"
                      :options="locationTypes"
                      v-model="tsLocationType"
                      :reduce="locationType => locationType.id"
                      class="w-full pr-3"
                    />
                    <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3" v-if="isMuckOperationSelected">
                <vs-col vs-w="12">
                  <form-label>{{$t('GradeControl.Location.Name')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Location.Name')" rules="required" v-slot="{ errors }">
                    <v-select
                      label="code"
                      :disabled="tsLocationType === null"
                      :options="filteredLocations"
                      :reduce="location => location.locationId"
                      v-model="tsLocationId"
                      class="w-full"
                    />
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                  <small v-if="showActualLocation">{{ $t('Actual') }} : {{ tsLocationCode }}</small>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3" v-if="isMuckOperationSelected">
                <vs-col class="mr-5" vs-w="5">
                  <form-label>{{$t('GradeControl.Timesheet.BlastType')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Timesheet.BlastType')" v-slot="{ }">
                   <v-select
                      label="name"
                     :options="blastTypes"
                      v-model="tsBlastType"
                      :reduce="blastType => blastType.id"
                      class="w-full"
                    />
                  </ValidationProvider>
                </vs-col>
                <vs-col  vs-w="6">
                  <ValidationProvider :name="$t('GradeControl.Timesheet.RoundNumber')" rules="numeric|between:0,9999" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GradeControl.Timesheet.RoundNumber')"
                      v-model="tsRoundNumber"
                      name="roundNumber"
                    ></validated-input>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3" v-if="isMuckOperationSelected">
                <vs-col vs-w="12" >
                  <form-label>{{$t('GradeControl.Timesheet.Destination')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Timesheet.Destination')" :rules="{ destinationNotSameAsLocation: { location: tsLocationCode } }" v-slot="{ errors }">
                    <v-select
                      label="name"
                      taggable
                      :options="destinations"
                      :reduce="destination => destination.name"
                      v-model="tsDestination"
                      class="w-full pr-3"
                    />
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>

              <vs-row class="mb-3" v-if="isRemuckOperationSelected">
                <vs-col vs-w="12">
                  <form-label>{{$t('GradeControl.Timesheet.Source')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Timesheet.Source')" :rules="{ required: true, destinationNotSameAsLocation: { location: tsDestination } }" v-slot="{ errors }">
                    <v-select
                      label="name"
                      :options="sourceDestinations"
                      :reduce="destination => destination.name"
                      v-model="tsLocationCode"
                      class="w-full pr-3"
                    />
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3" v-if="isRemuckOperationSelected">
                <vs-col vs-w="12" >
                  <form-label>{{$t('GradeControl.Timesheet.Destination')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Timesheet.Destination')" v-slot="{ errors }">
                    <v-select
                      label="name"
                      :options="remuckDestinations"
                      :reduce="destination => destination.name"
                      v-model="tsDestination"
                      class="w-full pr-3"
                    />
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>

              <vs-row >
                <vs-col vs-w="6">
                  <form-label>{{$t('GradeControl.Equipment.Name')}}</form-label>
                  <vs-checkbox v-model="tsIsEquipmentContractual" class="mb-2">{{$t('GradeControl.Contractual')}}</vs-checkbox>
                </vs-col>
                <vs-col class="mt-5" vs-w="6">
                  <vs-checkbox v-model="onlyActiveEquipment" class="mb-2">{{$t('GradeControl.Equipment.OnlyActive')}}</vs-checkbox>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3">
                <vs-col vs-w="12">
                  <ValidationProvider :name="$t('GradeControl.Equipment.Name')" rules="required" v-slot="{ errors }">
                    <v-select
                      label="displayName"
                      :options="filteredEquipments"
                      :reduce="equipment => equipment.code"
                      v-model="tsEquipmentCode"
                      class="w-full pr-3">
                      <template #option="{ code, company }">
                        {{ code }} - {{ company }}
                      </template>
                    </v-select>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row >
                <vs-col vs-w="6">
                  <vs-checkbox v-model="tsIsAutomation" class="mb-2">{{$t('GradeControl.Timesheet.IsAutomation')}}</vs-checkbox>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col class="mb-3" vs-w="12">
                  <form-label>{{$t('GradeControl.Timesheet.Employee')}}</form-label>
                  <vs-checkbox v-model="tsIsEmployeeContractual" class="mb-2">{{$t('GradeControl.Contractual')}}</vs-checkbox>
                  <v-select
                    label="displayName"
                    :options="filteredEmployees"
                    :reduce="employee => employee.code"
                    v-model="tsEmployeeCode"
                    class="w-full pr-3"
                    name="employeeCode"
                  />
                </vs-col>
              </vs-row>
              <vs-row class="mb-3">
                <vs-col class="mr-5" vs-w="8">
                  <form-label>{{$t('GradeControl.MuckType.ModelName')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.MuckType.ModelName')" rules="required" v-slot="{ errors }">
                    <v-select
                      label="name"
                      :options="$props.muckTypes"
                      :reduce="muckType => muckType.muckTypeId"
                      v-model="tsMuckTypeId"
                      class="w-full"
                    />
                    <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="3" v-if="useBucketInput">
                  <ValidationProvider :name="$t('GradeControl.Timesheet.BucketCount')" rules="required|numeric|between:0,500" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GradeControl.Timesheet.BucketCount')"
                      v-model="tsBucketCount"
                    ></validated-input>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              <vs-col vs-w="3" v-if="!useBucketInput">
                  <ValidationProvider :name="$t('GradeControl.Timesheet.Tonnage')" rules="required|decimal:2|between:0,5000" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GradeControl.Timesheet.Tonnage')"
                      v-model="tsTonnage"
                    ></validated-input>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row class="mb-3" v-if="useBucketInput">
                <vs-col class="" vs-w="5">
                  <validated-input
                    :disabled="true"
                    v-model="locationForecastDensity"
                    :label="densityTitle"
                  ></validated-input>
                </vs-col>
                <vs-col class="pl-5" vs-w="3">
                  <form-label>{{ $t('GradeControl.Timesheet.OverrideDensity') }}</form-label>
                  <vs-switch class="mt-2" color="primary" icon-pack="feather" vs-icon-on="icon-check" vs-icon-off="icon-x" v-model="overrideDensity">
                    <span slot="on"></span>
                    <span slot="off"></span>
                  </vs-switch>
                </vs-col>
                <vs-col class="pl-4 pr-3" vs-w="4" v-if="overrideDensity">
                  <ValidationProvider :name="$t('GradeControl.Timesheet.Density')" rules="decimal" v-slot="{ errors }">
                    <validated-input
                      :label="$systemUnits.getDensityLabel()"
                      v-model="density"
                    ></validated-input>
                    <validation-message>{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
               <vs-row class="mb-3">
                <vs-col class="mr-5"  vs-w="8">
                  <form-label>{{$t('GradeControl.Timesheet.MaterialType')}}</form-label>
                  <ValidationProvider :name="$t('GradeControl.Timesheet.MaterialType')" rules="required" v-slot="{ errors }">
                    <v-select
                      label="name"
                     :options="materialTypes"
                      v-model="tsMaterialType"
                      :reduce="materialType => materialType.id"
                      @input="setMaterialType"
                      class="w-full"
                    />
                    <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row v-if="isMaterialSubTypeEnabled">
                <vs-col class="pr-5"  vs-w="8">
                  <form-label>{{$t('GradeControl.MaterialSubType.ModelName')}}</form-label>
                  <v-select
                    label="name"
                    :options="filteredMaterialSubTypes"
                    v-model="tsMaterialSubTypeId"
                    :reduce="materialSubType => materialSubType.materialSubTypeId"
                    class="w-full"
                  />
                </vs-col>
                <vs-col class="mt-8" vs-w="4">
                  <vs-checkbox v-model="onlyActiveMaterialSubType" class="mb-2">{{$t('GradeControl.MaterialSubType.OnlyActive')}}</vs-checkbox>
                </vs-col>
              </vs-row>
            </form>
          </ValidationObserver>
        </tab-content>
        <tab-content :title="$t('GradeControl.Timesheet.SampleRanges')" class="mb-2" :before-change="validateStep2">
          <ValidationObserver ref="step2Observer" >
            <!-- Gold content -->
            <form data-vv-scope="step-2">
              <vs-row>
                <vs-col id="tableCol" class="mb-3" vs-w="12">
                  <vs-row>
                    <vs-col  vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="5" vs-sm="2" vs-xs="12" >
                       <form-label>{{$t('GradeControl.Timesheet.SampleRanges')}}</form-label>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-lg="6" vs-sm="6" vs-xs="12" class="m-3" >
                      <feather-icon icon="PlusIcon" class="cursor-pointer" svg-classes="h-6 w-6" @click="addSampleRange()" />
                    </vs-col>
                  </vs-row>
                  <vs-list>
                    <vs-list-item v-for="(listItem, index) in tsSampleRanges" :key="index" :title="listItem.sampleStart + ' - ' + listItem.sampleEnd">
                      <feather-icon icon="EditIcon" class="cursor-pointer mr-3" svg-classes="h-4 w-4" @click="editSampleRange(index, listItem)" />
                      <feather-icon icon="TrashIcon" class="cursor-pointer" svg-classes="h-4 w-4" @click="deleteSampleRange(index)" />
                    </vs-list-item>
                  </vs-list>
                  <vs-divider/>
                </vs-col>
              </vs-row>
              <div v-show="tsSampleEditMode">
                <vs-row  class="mb-5" vs-type="flex">
                  <vs-col vs-w="3" class="mr-5">
                    <ValidationProvider name="sampleStart" rules="numeric" v-slot="{ errors }">
                      <validated-input
                        :label="$t('GradeControl.Timesheet.SampleStartShort')"
                        v-model="tsSampleStart"
                      ></validated-input>
                      <validation-message
                        >{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                  </vs-col>
                  <vs-col vs-w="3" class="mr-5">
                    <ValidationProvider :name="$t('GradeControl.Timesheet.SampleEndShort')" rules="numeric" v-slot="{ errors }">
                      <validated-input
                        :label="$t('GradeControl.Timesheet.SampleEndShort')"
                        v-model="tsSampleEnd"
                      ></validated-input>
                      <validation-message
                        >{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                  </vs-col>
                  <vs-col vs-w="2" class="mt-5" >
                    <vs-button v-show="tsSampleCreateMode" @click="insertRange">{{$t('Apply')}}</vs-button>
                    <vs-button v-show="tsSampleUpdateMode" @click="updateRange">{{$t('Apply')}}</vs-button>
                  </vs-col>
                </vs-row>
                <vs-row class="mb-5" vs-type="flex">
                  <vs-col vs-w="5">
                    <form-label>{{$t('GradeControl.Timesheet.OverridePrefix')}}</form-label>
                  </vs-col>
                  <vs-col vs-w="3">
                    <vs-checkbox v-model="tsOverridePrefix"></vs-checkbox>
                  </vs-col>
                </vs-row>
                <vs-row class="mb-5" vs-type="flex">
                  <vs-col>
                    <ValidationProvider :name="$t('GradeControl.Timesheet.SamplePrefix')" v-slot="{ errors }">
                      <validated-input v-show="tsOverridePrefix"
                          :label="$t('GradeControl.Timesheet.SamplePrefix')"
                          v-model="tsSamplePrefix"
                        ></validated-input>
                        <validation-message
                          >{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                  </vs-col>
                </vs-row>
              </div>
              <vs-row class="mb-5" vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="12">
                  <form-label>{{$t('GradeControl.Timesheet.SampleCountShort')}}</form-label>
                  <h4 class="mt-2 ml-1">{{ tsSampleCount }}</h4>
                </vs-col>
              </vs-row>
            </form>
          </ValidationObserver>
        </tab-content>
      </form-wizard>
    </ValidationObserver>
  </sidebar>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import { extend } from 'vee-validate';
import MaterialTypeEnum  from "../../MaterialTypeEnum.js";
import LocationTypeEnum from "../../LocationTypeEnum.js";
import BlastTypeEnum from "../../BlastTypeEnum.js";
import ShiftEnum from "../../../../shared/ShiftEnum.js";
import TimesheetOperationTypeEnum from "../../TimesheetOperationTypeEnum.js";
import EquipmentTypeEnum from "../../EquipmentTypeEnum";
import DestinationTypeEnum from "../../DestinationTypeEnum.js";
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../../shared/components";


export default {
  props: {
    initialDate: {
      type: Date,
      required: false
    },
    equipments: {
      type: Array,
      required: true
    },
    locations: {
      type: Array,
      required: true
    },
    destinations: {
      type: Array,
      required: true
    },
    employees: {
      type: Array,
      required: true
    },
    muckTypes: {
      type: Array,
      required: true
    },
    materialSubTypes: {
      type: Array,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FormWizard,
    TabContent,
    'v-select': vSelect,
    Datepicker,
    FormLabel,
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      tsId: 0,
      tsProjectId: 0,
      tsExtractionDate: new Date(),
      tsBlastDate: null,
      tsLocationId: null,
      tsLocationCode: null,
      tsEquipmentCode: null,
      tsEmployeeCode: null,
      tsIsEmployeeContractual: null,
      tsIsEquipmentContractual: null,
      tsIsAutomation: false,
      tsSupportingResource: "",
      tsMuckTypeId: null,
      tsShift: 0,
      tsTonnage: null,
      tsBucketCount: 0,
      tsDestination: "",
      tsBlastType: null,
      tsRoundNumber: null,
      tsRockType: "",
      tsMaterialType: 0,
      tsMaterialSubTypeId: null,
      tsSampleStart: null,
      tsSampleEnd: null,
      tsSampleCount: null,
      tsSampleUpdateMode: false,
      tsSampleCreateMode: false,
      tsSampleEditionIndex : null,
      tsLocationType: 0,
      tsTimesheetImportationId: null,
      tsTimestamp: null,
      tsComments: "",
      tsSampleRanges: [],
      tsSamplePrefix: "",
      tsOverridePrefix: false,
      isLoading : false,
      tsTimesheetOperationType: null,
      onlyActiveEquipment: true,
      onlyActiveMaterialSubType: true,
      shifts: [
        { id: ShiftEnum.Day, label: this.$t("Shift." + ShiftEnum.Day) },
        { id: ShiftEnum.Night, label:  this.$t("Shift." + ShiftEnum.Night) }
      ],
      locationTypes: LocationTypeEnum.definition,
      materialTypes: MaterialTypeEnum.definition,
      blastTypes: BlastTypeEnum.definition,
      timesheetOperationTypes: TimesheetOperationTypeEnum.definition,
      overrideDensity: false,
      density: 0.0,
      locationForecastDensity: 0.0,
      externalKey: null
    };
  },
  watch: {
    tsLocationCode() {
      this.getLocationDensity();
    },
    tsExtractionDate() {
      this.getLocationDensity();
    },
    tsTimesheetOperationType() {
      if (this.tsTimesheetOperationType !== TimesheetOperationTypeEnum.Muck) {
        this.tsBlastDate = null;
      }
      this.getLocationDensity();
      this.updateEquipmentCode();
    },
    tsLocationId() {
      const location = this.$props.locations.find(e => e.locationId === this.tsLocationId);
      this.tsLocationCode = location ? location.code : this.tsLocationCode;
    }
  },
  computed: {
    isMaterialSubTypeEnabled() {
      return this.$props.materialSubTypes.length > 0;
    },
    defaultMuckType() {
      const type = this.$props.muckTypes.find(m => m.code === 'N');
      if (type)
        return type.muckTypeId;

      return null;
    },
    filteredLocations() {
      return this.$props.locations.filter(e => e.type === this.tsLocationType);
    },
    filteredMaterialSubTypes() {
      if (this.onlyActiveMaterialSubType) {
        return this.$props.materialSubTypes.filter(e => e.materialType === this.tsMaterialType && e.isActive === true);
      } else {
        return this.$props.materialSubTypes.filter(e => e.materialType === this.tsMaterialType);
      }
    },
    filteredEmployees() {
      const emp = this.$props.employees.filter(e => e.isContractual === this.tsIsEmployeeContractual);
      return emp;
    },
    tsSampleEditMode() {
      return this.tsSampleCreateMode || this.tsSampleUpdateMode;
    },
    filteredEquipments() {
      let filteredEquipments = [];
      if (this.onlyActiveEquipment) {
        filteredEquipments = this.$props.equipments.filter(e => e.isContractual === this.tsIsEquipmentContractual && e.isActive === true);
      } else {
        filteredEquipments = this.$props.equipments.filter(e => e.isContractual === this.tsIsEquipmentContractual);
      }
      return filteredEquipments.filter(e => (this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Muck && e.type === EquipmentTypeEnum.Scoop)
                                         || (this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Hauling && e.type === EquipmentTypeEnum.Truck)
                                         || (this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Remuck));
    },
    isMuckOperationSelected() {
      return this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Muck || this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Hauling;
    },
    isHaulingOperationSelected() {
      return this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Hauling;
    },
    isRemuckOperationSelected() {
      return this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Remuck;
    },
    sourceDestinations() {
      return this.$props.destinations.filter(e => e.destinationType !== DestinationTypeEnum.OrePass);
    },
    remuckDestinations() {
      return this.$props.destinations.filter(e => e.name !== this.tsLocationCode);
    },

    densityTitle() {
      if (this.isMuckOperationSelected) return this.$t('GradeControl.Timesheet.LocationForecastDensity');
      return this.$t('GradeControl.RemuckForecast.Title');
    },
    addNewPageTitle() {
      if (this.tsTimesheetOperationType !== null) {
        return this.$t('GradeControl.Timesheet.AddNew') + ' (' + TimesheetOperationTypeEnum.getNameFor(this.tsTimesheetOperationType) + ')';
      }
      return this.$t('GradeControl.Timesheet.AddNew');
    },
    editPageTitle() {
      if (this.tsTimesheetOperationType !== null) {
        return this.$t('GradeControl.Timesheet.Edit') + ' (' + TimesheetOperationTypeEnum.getNameFor(this.tsTimesheetOperationType) + ')';
      }
      return this.$t('GradeControl.Timesheet.Edit');
    },
    useBucketInput() {
      return this.$store.getters.isProjectUsingBucketInput;
    },
    showActualLocation() {
      if (this.tsLocationId !== undefined && this.tsLocationId !== null && this.$props.locations.length > 0) {
        const location = this.$props.locations.find(l => l.locationId === this.tsLocationId);
        if (location) {
          return location.code !== this.tsLocationCode;
        }
      }
      return true;
    }
  },

  created() {
    extend('destinationNotSameAsLocation', {
      params: ['location'],
      validate: (value, { location }) => {
        return !(value && location && value === location);
      },
      message: () => this.$t('GradeControl.Timesheet.DestinationCannotBeSameAsLocation')
    });
  },

  methods: {
    setMaterialType(type) {
      this.tsMaterialType = type;
      this.tsMaterialSubTypeId = null;
    },
    newData() {
      this.initValues();
      this.tsExtractionDate = this.initialDate;
      this.onlyActiveEquipment = true;
      this.onlyActiveMaterialSubType = true;
      this.tsSampleCreateMode = false;
      this.tsSampleUpdateMode = false;


      this.$refs.wizard.reset();
      this.$refs.step1Observer.reset();
      this.$refs.step2Observer.reset();
    },
    editData() {
      const {
        timesheetStagingEntryId,
        projectId,
        extractionDate,
        blastDate,
        locationId,
        locationCode,
        equipmentCode,
        isEquipmentContractual,
        employeeCode,
        isEmployeeContractual,
        isAutomation,
        supportingResource,
        muckTypeId,
        shift,
        bucketCount,
        locationType,
        sampleRanges,
        destination,
        rockType,
        materialType,
        materialSubTypeId,
        blastType,
        roundNumber,
        samplePrefix,
        timesheetImportationId,
        timestamp,
        comments,
        timesheetOperationType,
        overrideDensity,
        density,
        tonnage,
        externalKey} = JSON.parse(JSON.stringify(this.data));
      this.tsId = timesheetStagingEntryId;
      this.tsProjectId = projectId;
      this.tsExtractionDate = extractionDate;
      this.tsBlastDate = blastDate;
      this.tsLocationId = locationId;
      this.tsLocationCode = locationCode;
      this.tsEquipmentCode = equipmentCode;
      this.tsIsEquipmentContractual = isEquipmentContractual;
      this.tsEmployeeCode = employeeCode;
      this.tsIsEmployeeContractual = isEmployeeContractual;
      this.tsMuckTypeId = muckTypeId;
      this.tsShift = shift;
      this.tsBucketCount = bucketCount;
      this.tsTonnage = (tonnage === null) ? 0 : (tonnage % 1 === 0 || tonnage.toFixed(2) % 1 === 0) ? tonnage.toFixed(0) : tonnage.toFixed(2);
      this.tsDestination = destination;
      this.tsBlastType = blastType;
      this.tsRoundNumber = roundNumber;
      this.tsRockType = rockType;
      this.tsIsAutomation = isAutomation;
      this.tsSupportingResource = supportingResource;
      this.tsMaterialType = materialType;
      this.tsMaterialSubTypeId = materialSubTypeId;
      this.tsLocationType = locationType;
      this.tsSampleRanges = sampleRanges;
      this.tsSamplePrefix = samplePrefix;
      this.tsOverridePrefix = samplePrefix !== null && samplePrefix !== "";
      this.tsTimestamp = timestamp;
      this.tsComments = comments;
      this.tsTimesheetOperationType = timesheetOperationType;
      this.externalKey = externalKey;

      const equipment = this.$store.state.gradeControl.equipments.find(l => l.code === this.tsEquipmentCode && l.isContractual === this.tsIsEquipmentContractual);
      if (equipment !== undefined && equipment.type === EquipmentTypeEnum.Truck && this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Muck) {
        this.tsTimesheetOperationType = TimesheetOperationTypeEnum.Hauling;
      }

      this.tsTimesheetImportationId = timesheetImportationId;

      this.overrideDensity = overrideDensity;
      this.density = this.$systemUnits.convertDensity(density);

      const selectedEquipment = this.$props.equipments.find(e => e.code === equipmentCode);
      if (selectedEquipment) {
        this.onlyActiveEquipment = selectedEquipment.isActive;
      } else {
        this.onlyActiveEquipment = true;
      }

      const selectedMaterialSubType = this.$props.materialSubTypes.find(e => e.materialSubTypeId === materialSubTypeId);
      if (selectedMaterialSubType) {
        this.onlyActiveMaterialSubType = selectedMaterialSubType.isActive;
      } else {
        this.onlyActiveMaterialSubType = true;
      }

      this.tsSampleCreateMode = false;
      this.tsSampleUpdateMode = false;

      if (this.tsLocationId !== undefined && this.tsLocationId !== null) {
        const location = this.$props.locations.filter(e => e.locationId === this.tsLocationId)
        if (location.length > 0)
          this.tsLocationType = location[0].type;
      }
      this.defineSampleCount();
      this.$refs.wizard.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;

      this.tsId = 0;
      this.tsProjectId = this.projectId;
      this.tsExtractionDate = null;
      this.tsBlastDate = null;
      this.tsLocationId = null;
      this.tsLocationCode = null;
      this.tsEquipmentCode = null;
      this.tsIsEquipmentContractual = false;
      this.tsEmployeeCode = null;
      this.tsIsEmployeeContractual = false;
      this.tsMuckTypeId = this.defaultMuckType;
      this.tsShift = null;
      this.tonnage = null;
      this.tsBucketCount = 0;
      this.tsTonnage = null;
      this.tsDestination = "";
      this.tsBlastType = null;
      this.tsRoundNumber = null;
      this.tsRockType = "";
      this.tsIsAutomation = false;
      this.tsSupportingResource = "";
      this.tsMaterialType = 0;
      this.tsMaterialSubTypeId = null;
      this.tsSamplePrefix = null;
      this.tsSampleRanges = [];
      this.tsSampleCount = null;
      this.tsSamplePrefix = "";
      this.tsLocationType = null;
      this.tsTimesheetImportationId = null;
      this.tsSampleEditionIndex = null;
      this.tsOverridePrefix = false;
      this.tsTimestamp = null;
      this.tsComments = "";
      this.tsTimesheetOperationType = TimesheetOperationTypeEnum.Muck;

      this.overrideDensity = false;
      this.density = 0.0;
      this.locationForecastDensity = 0.0;
      this.externalKey = null;
    },

    defineSampleCount() {
      let count = 0;
      this.tsSampleRanges.forEach(range => {
        const start = parseInt(range.sampleStart, 10);
        const end = parseInt(range.sampleEnd, 10);

        if (!isNaN(start) && !isNaN(end)) {
          count += end - start + 1;
        }
      });

      this.tsSampleCount = count > 0 ? count : 0;
    },
    insertRange() {
      const newRange = {
        timesheetStagingEntryId : this.tsId,
        sampleStart : this.tsSampleStart,
        sampleEnd : this.tsSampleEnd
      };

      this.tsSampleRanges.push(newRange);
      this.defineSampleCount();
      this.tsSampleCreateMode = false;
    },
    updateRange() {
      if (this.tsSampleEditionIndex === null)
        return;

      this.tsSampleRanges[this.tsSampleEditionIndex].sampleStart = this.tsSampleStart;
      this.tsSampleRanges[this.tsSampleEditionIndex].sampleEnd = this.tsSampleEnd;

      this.defineSampleCount();
      this.tsSampleUpdateMode = false;
      this.tsSampleEditionIndex = null;
    },
    editSampleRange(index, range) {
      this.tsSampleStart = range.sampleStart;
      this.tsSampleEnd = range.sampleEnd;
      this.tsSampleEditionIndex = index;
      this.tsSampleCreateMode = false;
      this.tsSampleUpdateMode = true;
    },
    addSampleRange() {
      this.tsSampleCreateMode = true;
      this.tsSampleUpdateMode = false;
      this.tsSampleStart = null;
      this.tsSampleEnd = null;
      this.tsSampleEditionIndex = null;
    },
    deleteSampleRange(index) {
      this.tsSampleRanges.splice(index, 1);
      this.defineSampleCount();
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.step1Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$refs.step2Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    submitData() {
      const obj = {
        timesheetStagingEntryId: this.tsId,
        projectId: this.tsProjectId,
        extractionDate: this.tsExtractionDate,
        blastDate: this.tsBlastDate,
        locationId: this.tsLocationId,
        locationCode: this.tsLocationCode,
        equipmentCode: this.tsEquipmentCode,
        isEquipmentContractual: this.tsIsEquipmentContractual,
        employeeCode: this.tsEmployeeCode,
        isEmployeeContractual: this.tsIsEmployeeContractual,
        // Apparently not!
        // muckTypeId: this.isMuckOperationSelected ? this.tsMuckTypeId : null,
        muckTypeId: this.tsMuckTypeId,
        shift: this.tsShift,
        tonnage: this.tsTonnage,
        bucketCount: this.tsBucketCount,
        destination: this.tsDestination,
        blastType: this.tsBlastType,
        roundNumber: this.isMuckOperationSelected ? this.tsRoundNumber : null,
        rockType: this.tsRockType,
        isAutomation : this.tsIsAutomation,
        supportingResource: this.tsSupportingResource,
        materialType: this.tsMaterialType,
        materialSubTypeId: this.tsMaterialSubTypeId,
        sampleRanges: this.tsSampleRanges,
        sampleCount: this.tsSampleCount,
        locationType: this.isMuckOperationSelected ? this.tsLocationType : null,
        samplePrefix: this.tsOverridePrefix ? this.tsSamplePrefix : null,
        timesheetImportationId: this.tsTimesheetImportationId,
        timestamp: this.tsTimestamp,
        comments: this.tsComments,
        timesheetOperationType: this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Hauling ? TimesheetOperationTypeEnum.Muck : this.tsTimesheetOperationType,

        overrideDensity: this.overrideDensity,
        density: (this.overrideDensity) ? this.$systemUnits.convertDensityToMetric(this.density) : null,
        externalKey: this.externalKey
      };

      if (Object.prototype.toString.call(this.tsExtractionDate) === "[object Date]") {
        obj.extractionDate = this.$options.filters.toDate(this.tsExtractionDate);
      }
      else {
        obj.extractionDate = this.tsExtractionDate;
      }

      if (this.tsTimesheetOperationType === TimesheetOperationTypeEnum.Muck) {
        if (Object.prototype.toString.call(this.tsBlastDate) === "[object Date]") {
          obj.blastDate = this.$options.filters.toDate(this.tsBlastDate);
        }
        else {
          obj.blastDate = this.tsBlastDate;
        }
      } else {
        obj.blastDate = null;
      }

      this.$vs.loading();
      if (this.tsId !== null && this.tsId > 0) {
        this.$store.dispatch("gradeControl/updateTimesheet", obj).then((result) => {
          this.$emit("onTimesheetUpdated", result.data);
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$emit("onRefreshTimesheets");
          }

        }).finally(() => {
          this.$vs.loading.close();
        });
      } else {
        this.$store.dispatch("gradeControl/addTimesheet", obj).then((result) => {
          this.$emit("onTimesheetInserted", result.data);
        }).finally(() => {
          this.$vs.loading.close();
        });
      }
    },
    getLocationDensity() {
      const extractionDateInvalid = this.tsExtractionDate === null || this.tsExtractionDate === undefined || this.tsExtractionDate === "";
      if (extractionDateInvalid) return;

      if (this.isMuckOperationSelected) {
        const locationCodeInvalid = this.tsLocationCode === null || this.tsLocationCode === undefined || this.tsLocationCode === "";
        if (locationCodeInvalid) return;

        const d = new Date(this.tsExtractionDate);
        this.$webApi.get("geo/gradeControl/locationForecast/GetLatestByLocationCode/", {
          params: {
            locationCode: this.tsLocationCode,
            extractionDate:  d.toDateString()
          }
        }).then((response) => {
          this.locationForecastDensity = this.$systemUnits.convertDensity(response.data);
        })
          .catch((err) => {
            this.$notifyLoadingError(err);
          })
      } else {
        const projectIdInvalid = this.tsProjectId === 0 || this.tsProjectId === null || this.tsProjectId === undefined;
        if (projectIdInvalid) return;

        this.$cqrsGet('geo/gradeControl/RemuckForecast/Find', { params: { projectId: this.tsProjectId, refDate: this.tsExtractionDate } })
          .then((response) => {
            this.locationForecastDensity = this.$systemUnits.convertDensity(response.data.model.density);
          })
          .catch((err) => {
            console.error(err);
          })
      }

    },
    updateEquipmentCode() {
      if (this.filteredEquipments.find(o => o.code === this.tsEquipmentCode && o.isContractual === this.tsIsEquipmentContractual) === undefined) {
        this.tsEquipmentCode = null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 435px;
    max-width: 90vw;
  }
}

#tableCol {
  .vs-table--header {
    display: flex;
    flex-wrap: wrap;
    margin-left: 1.5rem;
    margin-right: 1.5rem;

    > span {
      display: flex;
      flex-grow: 1;
    }
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 1.3rem;
    padding: 0 1rem;
    width: 200px;

    tr {
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
      width: 200px;
      td {
        padding: 20px;
        &:first-child {
          border-top-left-radius: 0.5rem;
          border-bottom-left-radius: 0.5rem;
        }
        &:last-child {
          border-top-right-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
        }
      }
      td.td-check {
        padding: 20px !important;
      }
    }
  }

  .vs-table--thead {
    th {
      padding-top: 0;
      padding-bottom: 0;
      width: 200px;

      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
      }
    }
    th.td-check {
      padding: 0 15px !important;
    }
    tr {
      background: none;
      box-shadow: none;
      width: 200px;

    }
  }

  .vs-table--tbody-table {
    min-width: 200px;
  }
}

::v-deep .blast-date-picker > div:first-child {
  display: flex;
  align-items: center;
  width: 100%;
}

::v-deep .blast-date-picker input {
  flex: 1 1 auto;
  min-width: 0;
}

::v-deep .blast-date-picker .vdp-datepicker__clear-button {
  margin-left: 0.5rem;
  line-height: 1;
  white-space: nowrap;
}
</style>
